import { WebStaticHosts } from '../hosts';
import { Stands } from '../Stands';

export const daData = {
	[Stands.test]: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs',
	[Stands.cert]: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs',
	[Stands.prod]: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs',
};

export const commonServiceApis: Record<
	keyof typeof commonServiceKeysApis,
	Record<Stands, string>
> = {
	daData,
	webStaticApi: WebStaticHosts,
};
export const commonServiceKeysApis = {
	daData: 'daData',
	webStaticApi: 'webStaticApi',
};
